import { call, put, takeEvery } from "redux-saga/effects";
import { fetchChatMessagesRequest, fetchChatMessagesSuccess, fetchChatMessagesFailure } from "../slice/chatSlice";
import { fetchChatMessagesApi } from "../../api/apiService";
import axios, { AxiosError } from "axios";
import { getApiError } from "@src/utils/apiError";

function* fetchChatMessages(action: { payload: { session_id: number | string} }): Generator<any, void, any> {
    try {
        const response = yield call(fetchChatMessagesApi, action.payload);
        yield put(fetchChatMessagesSuccess(response.data));
    } catch (error: unknown) {
        const apiError = getApiError(error);

        yield put(
            fetchChatMessagesFailure({
                message: apiError.message,
                code: apiError.status,
            })
        );
    }
}

export function* chatSaga() {
    yield takeEvery(fetchChatMessagesRequest, fetchChatMessages);
}
